// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2yU_W","productName":"Table_productName__1gm-R"};